import { render, staticRenderFns } from "./ArchiveGlobalPage.vue?vue&type=template&id=20c71210"
import script from "./ArchiveGlobalPage.vue?vue&type=script&lang=js"
export * from "./ArchiveGlobalPage.vue?vue&type=script&lang=js"
import style0 from "./ArchiveGlobalPage.vue?vue&type=style&index=0&id=20c71210&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports